import { DesigntimeComponent } from './DesigntimeComponent.js'
import componentHelpers from './componentHelpers.js'
import { LiquidString } from '../common/LiquidString.js'
import * as $ from 'jquery';

class RealityOutput extends DesigntimeComponent {
    static staticName = "Output (realitycheck)";
    static staticId = "realityOutput";

    constructor(identifyer) {
        super(identifyer, 2);

        this.values = {};

        for (var i = 1; i < 6; i++) {
            this.values["header" + i] = new LiquidString(`Header ${i}`, `${this.id}_header${i}`);
            this.values["paragraphText" + i] = new LiquidString(`ParagraphText ${i}`, `${this.id}_paragraphText${i}`);
        }

        this.values.subTitle1 = new LiquidString("You said", `${this.id}_subTitle1`);
        this.values.info1won = new LiquidString("I have won {{inputValue}}", `${this.id}_info1won`);
        this.values.info1lost = new LiquidString("I have lost {{inputValue}}", `${this.id}_info1lost`);
        this.values.subTitle2 = new LiquidString("In reality", `${this.id}_subTitle2`);
        this.values.info2won = new LiquidString("I have won {{realValue}}", `${this.id}_info2won`);
        this.values.info2lost = new LiquidString("I have lost {{realValue}}", `${this.id}_info2lost`);
        this.values.buttontext = { value: "Next" };

        this.params = {
            inputValue: { key: "item_2:amount", value: 0 },
            realValue: { key: "url:monthlySpending", value: 0 },
            analysisValue: { key: "url:monthlySpending", value: 1 }
        };
    }

    getRuntimeView(context) {
        this.eventBroker.subscribe("valueChangedEvent", this.onRuntimeChanged.bind(this));

        var $outputPlaceholder = $("<div class='output-placeholder'></div>");

        $outputPlaceholder.append(this.getContent(1));

        return $outputPlaceholder;
    }

    getContent(contentVersion) {
        let allowedValues = [1, 2, 3, 4, 5];
        if (!allowedValues.includes(contentVersion)) {
            contentVersion = 1;
        }

        //1: RoughlyEqual
        //2:You seem to win more than you think
        //3:You seem to win less than you think
        //4:You seem to lose more than you think
        //5:You seem to lose less than you think

        var $outputContent = $("<div class='output-content'></div>");

        $outputContent.append(this.values[`header${contentVersion}`].getTag("h2", ""));

        $outputContent.append(this.values.subTitle1.getTag("p", "sid-info")); //"You said"
        if (this.params.inputValue.value > 0)
            $outputContent.append(this.values.info1won.getTag("p", "sid-info sid-info-bg")); //I have won
        else
            $outputContent.append(this.values.info1lost.getTag("p", "sid-info sid-info-bg")); //I have lost

        $outputContent.append(this.values.subTitle2.getTag("p", "sid-info")); //"In reality"
        if (this.params.realValue.value > 0)
            $outputContent.append(this.values.info2won.getTag("p", "sid-info")); //I have won
        else
            $outputContent.append(this.values.info2lost.getTag("p", "sid-info")); //I have lost

        $outputContent.append(this.values[`paragraphText${contentVersion}`].getTag("p", "sid-info"));

        return $outputContent;
    }

    onRuntimeChanged(eventParams) {
        if (eventParams.id == this.id)
            return;

        super.onRuntimeChanged(eventParams);

        for (var paramIndex in this.params) {
            if (this.params[paramIndex].key == eventParams.key) {
                this.params[paramIndex].value = eventParams.value;
                this.replaceParameter();
            }
        }
    }

    replaceParameter() {
        let $rtframe = componentHelpers.getRtFrame(this.id).find(`.output-placeholder`);

        $rtframe.empty()

        $rtframe.append(this.getContent(this.params.analysisValue.value));
    }

    importModel(model) {
        for (var param in model.params) {
            for (var i in this.values) {
                if (this.values[i] instanceof LiquidString)
                    this.values[i].replace(`{{${param}}}`, `{{${model.params[param].key}}}`);
            }
        }

        super.importModel(model);
    }
}

export { RealityOutput }
